import React from "react";
// import loadingGif from "../../assets/images/loading.gif"

const ButtonLoader = (props) => {
  return (
    <div>
      <div class="spinner-border spinner-border-sm" role="status" >
        <span class="sr-only"></span>
      </div>
    </div>
  );
};

export default ButtonLoader;
